import type { CategoryNavigationNode } from './category-navigation'
import type { CategoryEditorialFields } from './category-editorial-fields'

export type CategoryPublicDescription = { name: string; description: string }

function findCategoryEditorialSource(
  nodes: CategoryNavigationNode[],
  pathname: string
): (CategoryEditorialFields & { name: string }) | undefined {
  for (const node of nodes) {
    if (pathname === node.href) return node
    if (pathname === node.destinationHref) return { name: node.name, ...node.destinationEditorialFields }
    if (!pathname.startsWith(`${node.href}/`)) continue
    const child = findCategoryEditorialSource(node.children, pathname)
    if (child) return child
  }
}

export function findCategoryPublicDescription(
  nodes: CategoryNavigationNode[],
  pathname: string
): CategoryPublicDescription | undefined {
  const source = findCategoryEditorialSource(nodes, pathname)
  return source?.publicDescription ? { name: source.name, description: source.publicDescription } : undefined
}

export function findCategoryEditorialFields(
  nodes: CategoryNavigationNode[],
  pathname: string
): CategoryEditorialFields {
  const source = findCategoryEditorialSource(nodes, pathname)
  if (!source) return {}
  const { h1Title, introParagraph, publicDescription, summary1, summary2, quickTip } = source
  return { h1Title, introParagraph, publicDescription, summary1, summary2, quickTip }
}
